import { Login } from '@containers';

export default [
  {
    path: '/login',
    component: Login,
    exact: true,
  },
];
